import { deleteAPI, getAPI, postAPI, putAPI } from "utils/http";
import { apis } from "config/urls";

export async function getAllSuppliers({ token }) {
    return await getAPI(apis.suppliersAPI, {}, token);
}

export async function getRoles({ token }) {
    return await getAPI(apis.externalRolesAPI, {}, token);
}

export async function createSupplier(token, data) {
    return await postAPI(apis.suppliersAPI, { data }, token);
}

export async function deleteSupplierById(token, id) {
    return await deleteAPI(apis.suppliersAPI, { id }, token);
}

export async function editSupplier(token, data) {
    return await putAPI(apis.suppliersAPI, { data }, token);
}